import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { push } from 'redux-first-history';
import { useStateValidator } from 'react-use';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { Auth } from 'aws-amplify';
import replace from 'lodash/replace';
import queryString from 'query-string';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import validatePassword from '../../xhr_libs/password-validator';
import { setLoader } from '../../store/pages';
import ToastrMessages from '../../components/ToastrMessages';

export default function NewPasswordForm() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [name, setName] = useState('');
  const [email_, setEmail] = useState('');
  const [userSub, setUserSub] = useState('');
  const [code, setCode] = useState('');

  const [password, setPassword] = useState('');
  const [passwordValid] = useStateValidator(password, (password) => {
    return validatePassword(password);
  });
  const [passwordErrorText, setPasswordErrorText] = useState(null);

  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordErrorText, setConfirmPasswordErrorText] =
    useState(null);

  useEffect(() => {
    dispatch(setLoader(false));
  }, [dispatch]);

  useEffect(() => {
    let paramString = replace(location.hash, /#.*\?/i, '');
    let query = queryString.parse(paramString);

    if (query.code) setCode(query.code);
    if (query.email) setEmail(query.email);
    if (query.name) setName(query.name);
    if (query.user) setUserSub(query.user);
  }, [location]);

  const handleNavigate = (path) => {
    dispatch(push(path));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (passwordValid.errors.length > 0) {
      setPasswordErrorText('invalid');
      toastr.error('Password validation', {
        component: <ToastrMessages messages={passwordValid.errors} />,
      });
    } else if (confirmPassword !== password) {
      setConfirmPasswordErrorText('invalid');
      toastr.error('Passwords do not match');
    } else {
      try {
        dispatch(showLoading());

        await Auth.forgotPasswordSubmit(
          userSub, // the Cognito User Object
          code,
          password
        );

        toastr.success('Password updated');
        dispatch(push('/auth#login'));
      } catch (error) {
        console.error(error);
        toastr.error('Error', error.message ? error.message : error);
      } finally {
        dispatch(hideLoading());
      }
    }
  };

  return (
    <>
      <Typography variant='h4'>New Password</Typography>
      <List disablePadding>
        <form>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              disabled
              id='email_'
              label='Email'
              fullWidth
              variant='standard'
              value={email_}
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              disabled
              label='Name'
              fullWidth
              variant='standard'
              value={name}
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              id='password'
              error={!!passwordErrorText}
              label='Password'
              placeholder='Enter password'
              type='password'
              fullWidth
              required
              onChange={(e) => setPassword(e.target.value)}
              variant='standard'
              helperText={passwordErrorText}
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <TextField
              id='confirm-password'
              error={!!confirmPasswordErrorText}
              label='Confirm Password'
              placeholder='Re-enter password'
              type='password'
              fullWidth
              required
              onChange={(e) => setConfirmPassword(e.target.value)}
              variant='standard'
              helperText={confirmPasswordErrorText}
            />
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              fullWidth
              onClick={handleSubmit}>
              Submit
            </Button>
          </ListItem>
        </form>
      </List>
      <Link
        color='inherit'
        underline='hover'
        variant='body1'
        sx={{ cursor: 'pointer' }}
        onClick={() => handleNavigate('/auth')}>
        Back to Login
      </Link>
    </>
  );
}
